// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export const provinceValidation = {
    au: { required: true },
    aus: { required: true },

    br: { required: true },
    bra: { required: true },

    ca: { required: true },
    can: { required: true },

    ch: { required: true },
    che: { required: true },

    cl: { required: true },
    chl: { required: true },

    co: { required: true },
    col: { required: true },

    fr: { required: true },
    fra: { required: true },

    gb: { required: true },
    gbr: { required: true },

    gr: { required: true },
    grc: { required: true },

    il: { required: true },
    isr: { required: true },

    in: { required: true },
    ind: { required: true },

    jp: { required: true },
    jpn: { required: true },

    lv: { required: true },
    // lv: { required: true },

    mx: { required: true },
    mex: { required: true },

    nz: { required: true },
    nzl: { required: true },

    se: { required: true },
    swe: { required: true },

    us: { required: true },
    usa: { required: true },
};
